<template>
  <base-button variant="bordered-error"
             class="ml-3 px-5 btn-drop flex justify-center items-center"
             id="delete-button"
             :key="deleteButtonKey"
             @click="onClick"
  >
    <delete-icon/>
  </base-button>
</template>

<script>
import DeleteIcon from '@/assets/images/icons/DeleteIcon'

export default {
  name: 'DeleteButton',
  components: { DeleteIcon },

  data() {
    return {
      deleteButtonKey: 1
    }
  },

  methods: {
    onClick() {
      this.resetDeleteButton()
      this.$emit('click')
    },

    resetDeleteButton() {
      this.deleteButtonKey = Math.random()
    }
  }
}
</script>

<style>
#template-btn > i {
  font-size: 1.5rem;
}
</style>
